import React from "react";
import type { GatsbyBrowser } from "gatsby";
import Layout from "./components/layout/Layout";

/**
 * Hoist Layout (navbar/footer) here so it persists across client-side
 * navigation instead of being mounted inside each page. Mounting Layout
 * per-page caused it to unmount/remount on every navigation — reloading
 * the logo and reflowing the page each time. Wrapping at this level keeps
 * the same Layout instance mounted while only the page content swaps.
 *
 * Shared by both gatsby-browser and gatsby-ssr so SSR output and client
 * hydration produce the same tree.
 */
export const wrapPageElement: GatsbyBrowser["wrapPageElement"] = ({ element, props }) => {
  // The 404 page manages its own structure and intentionally has no Layout.
  // `custom404` is set by Gatsby when rendering the 404 component for an
  // unmatched route; the dedicated page resolves to the /404/ path.
  const isNotFound =
    Boolean((props as { custom404?: unknown })?.custom404) || props?.path === "/404/";

  if (isNotFound) {
    return element;
  }

  return <Layout>{element}</Layout>;
};
